<!-- One passcode dot. ON = glow + filled circle; OFF = open ring. -->
<svg *ngIf="variant === 'dot'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="8"></feGaussianBlur>
    </filter>
  </defs>

  <ng-container *ngIf="on">
    <circle cx="60" cy="60" r="44" [attr.fill]="color" opacity="0.32"
            [attr.filter]="'url(#' + uid + '-glow)'"></circle>
    <circle cx="60" cy="60" r="30" [attr.fill]="color"></circle>
  </ng-container>

  <!-- OFF: a hollow ring in the SAME colour as the ON dot, just empty inside. -->
  <circle *ngIf="!on" cx="60" cy="60" r="29" fill="none"
          [attr.stroke]="color" stroke-width="6"></circle>
</svg>

<!-- EVEREST: a dawn-gradient dot per digit (owner pick "B · Dawn Gradient").
     OFF = an empty sunrise-orange ring; ON = a filled circle washed in a
     vertical dawn gradient (soft peach up top into a deep sunrise orange
     below) behind a warm halo. -->
<svg *ngIf="variant === 'mountain'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- soft warm halo so the ON dot reads as lit -->
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="8"></feGaussianBlur>
    </filter>
    <!-- dawn wash: pale peach at the top fading into a deep sunrise orange -->
    <linearGradient [attr.id]="uid + '-dawn'" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#FBC9A6"></stop>
      <stop offset="1" stop-color="#E86A44"></stop>
    </linearGradient>
  </defs>

  <!-- OFF: an empty outline circle in the menu-button ON colour (orange). -->
  <circle *ngIf="!on" cx="60" cy="60" r="29" fill="none"
          stroke="#ED7E5A" stroke-width="6"></circle>

  <ng-container *ngIf="on">
    <!-- ON: warm halo + the dawn-gradient filled dot -->
    <circle cx="60" cy="60" r="44" fill="#ED7E5A" opacity="0.28"
            [attr.filter]="'url(#' + uid + '-glow)'"></circle>
    <circle cx="60" cy="60" r="30" [attr.fill]="'url(#' + uid + '-dawn)'"></circle>
  </ng-container>
</svg>

<!-- SAKURA: a kawaii cherry blossom per digit, each a little different (owner
     2026-07-24). OFF = an empty pink outline; ON = a filled blossom with a
     soft halo and a warm golden stamen centre. -->
<svg *ngIf="variant === 'blossom'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <!-- Petal shading: deep dusky-rose at the centre melting to lighter cherry
         pink at the tips (userSpaceOnUse so it spans the whole flower). -->
    <radialGradient [attr.id]="uid + '-petal'" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="44">
      <stop offset="0" [attr.stop-color]="skDeep"></stop>
      <stop offset="1" [attr.stop-color]="skLight"></stop>
    </radialGradient>
    <!-- Soft warm drop-shadow so the ON dots read as lit / pressed. -->
    <filter [attr.id]="uid + '-shadow'" x="-45%" y="-45%" width="190%" height="190%">
      <feDropShadow dx="0" dy="1.4" stdDeviation="1.8" flood-color="#7E3357" flood-opacity="0.32"></feDropShadow>
    </filter>
  </defs>

  <!-- ON: a filled cherry blossom — gradient-shaded petals (deep centre → light
       tips) with a THIN white keyline so they crisp-separate from the pink
       background, a golden stamen ring + centre, and a soft warm shadow. -->
  <g *ngIf="on" [attr.transform]="skGroupTransform" [attr.filter]="'url(#' + uid + '-shadow)'">
    <path *ngFor="let tf of skTransforms" [attr.d]="skPetal" [attr.transform]="tf"
          [attr.fill]="'url(#' + uid + '-petal)'" stroke="#FFFFFF" stroke-width="1.1"
          stroke-linejoin="round"></path>
    <circle *ngFor="let st of skStamenTransforms" cx="0" cy="0" r="1.9"
            [attr.transform]="st" fill="#F3B45E"></circle>
    <circle cx="0" cy="0" [attr.r]="skCore" fill="#FBE3A6"></circle>
    <circle cx="0" cy="0" [attr.r]="skCore * 0.45" fill="#F3B45E"></circle>
  </g>

  <!-- OFF: an EMPTY outline blossom in a soft PINK line (owner 2026-07-29, not
       white) — filled ON dots read as entered digits, outlines as remaining. -->
  <g *ngIf="!on" [attr.transform]="skGroupTransform">
    <path *ngFor="let tf of skTransforms" [attr.d]="skPetal" [attr.transform]="tf"
          fill="none" stroke="#FFD3E2" stroke-width="3.4" stroke-linejoin="round"></path>
  </g>
</svg>

<!-- TOKYO: a detailed steel-LATTICE Tokyo Tower per digit (owner 2026-08-05) in
     ONE colour (the theme's colour circle 2). A criss-cross truss mesh fills the
     silhouette. OFF = a faint empty tower; ON = the full lit lattice + a halo. -->
<svg *ngIf="variant === 'tower'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <clipPath [attr.id]="uid + '-twclip'"><path [attr.d]="twTower"></path></clipPath>
  </defs>

  <!-- ON: a soft halo, the lattice truss mesh, the crisp outline + decks. -->
  <!-- ON: two-tone — a solid international-orange body with a WHITE lattice truss
       and white observation decks, plus a soft lit halo. -->
  <ng-container *ngIf="on">
    <path [attr.d]="twTower" [attr.fill]="color" opacity="0.26"
          [attr.filter]="'url(#' + uid + '-glow)'"></path>
    <path [attr.d]="twTower" [attr.fill]="color"></path>
    <g [attr.clip-path]="'url(#' + uid + '-twclip)'">
      <path *ngFor="let l of twMesh" [attr.d]="l" fill="none" [attr.stroke]="twLight"
            stroke-width="2.1" stroke-linecap="round" opacity="0.95"></path>
    </g>
    <rect *ngFor="let d of twDecks" [attr.x]="d.x" [attr.y]="d.y" [attr.width]="d.w"
          [attr.height]="d.h" rx="1.2" [attr.fill]="twLight"></rect>
    <path [attr.d]="twTower" fill="none" [attr.stroke]="twLight" stroke-width="2.2"
          stroke-linejoin="round"></path>
  </ng-container>

  <!-- OFF: an empty WHITE wireframe — a faint lattice truss + a crisp outline. -->
  <ng-container *ngIf="!on">
    <g [attr.clip-path]="'url(#' + uid + '-twclip)'" opacity="0.5">
      <path *ngFor="let l of twMesh" [attr.d]="l" fill="none" stroke="#FFFFFF"
            stroke-width="1.6" stroke-linecap="round"></path>
    </g>
    <path [attr.d]="twTower" fill="none" stroke="#FFFFFF" stroke-width="2.4"
          stroke-linejoin="round" opacity="0.95"></path>
  </ng-container>
</svg>

<!-- EVEREST: the summit itself, one per digit (the 2026-08-06 restart) — the
     theme's hero motif, the way Sakura's is the blossom. ON = the peak lit by
     dawn (warm sunrise wash up the flank, bright snowcap, soft halo); OFF = the
     same silhouette as an empty pale-ice outline, so filled reads "entered". -->
<svg *ngIf="variant === 'peak'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <!-- The rock: glacier blue, a touch lighter up top where the sky hits it. -->
    <linearGradient [attr.id]="uid + '-rock'" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#7DB1CF"></stop>
      <stop offset="1" stop-color="#4E86A8"></stop>
    </linearGradient>
    <!-- Soft cool shadow so the summit sits on the passcode zone. -->
    <filter [attr.id]="uid + '-shadow'" x="-45%" y="-45%" width="190%" height="190%">
      <feDropShadow dx="0" dy="1.4" stdDeviation="1.8" flood-color="#0E3448" flood-opacity="0.24"></feDropShadow>
    </filter>
  </defs>

  <!-- ON: the BLUE mountain under its white snowcaps, nothing behind it. (A warm
       sunrise wash was tried behind the ridge on 2026-08-12 and dropped — owner:
       it did not read well at dot size.) -->
  <g *ngIf="on" [attr.transform]="pkTransform">
    <g [attr.filter]="'url(#' + uid + '-shadow)'">
      <path [attr.d]="pkBody" [attr.fill]="'url(#' + uid + '-rock)'"></path>
      <path [attr.d]="pkCap" fill="#FFFFFF"></path>
      <path [attr.d]="pkCapSmall" fill="#FFFFFF"></path>
    </g>
  </g>

  <!-- OFF: the empty silhouette — the digits still to come — in the tab bar's
       icy OFF tone, the same OFF/ON pairing the menu buttons use. (It started as
       a pale #CFE6F2, which all but disappeared once LINE's default skin turned
       the passcode zone WHITE; owner screenshot 2026-08-12.) -->
  <g *ngIf="!on" [attr.transform]="pkTransform">
    <path [attr.d]="pkBody" fill="none" stroke="#7DA1AF" stroke-width="4"
          stroke-linejoin="round"></path>
  </g>
</svg>

<!-- AURORA: each digit is a porthole onto the theme's own night (owner
     2026-08-12, after a gem and a loose curl of light were both rejected). Every
     orb mixes all three aurora colours and the four are composed differently.
     ON = the sky lit, over a halo in that digit's colour; OFF = the very same
     orb with the light off — dark glass, stars, dim rim. -->
<svg *ngIf="variant === 'orb'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="9"></feGaussianBlur>
    </filter>
    <filter [attr.id]="uid + '-soft'" x="-30%" y="-30%" width="160%" height="160%">
      <feGaussianBlur stdDeviation="2.4"></feGaussianBlur>
    </filter>
    <!-- The lit rim carries the whole aurora sweep rather than one colour. -->
    <linearGradient [attr.id]="uid + '-orbrim'" x1="0" y1="0" x2="1" y2="1">
      <stop *ngFor="let s of orbRimStops" [attr.offset]="s.off" [attr.stop-color]="s.color"></stop>
    </linearGradient>
    <clipPath [attr.id]="uid + '-orbclip'">
      <circle cx="60" cy="60" [attr.r]="orbR"></circle>
    </clipPath>
  </defs>

  <!-- ON: the lit sky. OFF is JUST the ring — no glass, no stars (owner
       2026-08-12), the same way Sakura's unentered digit is only an outline. -->
  <ng-container *ngIf="on">
    <circle cx="60" cy="60" r="49" [attr.fill]="orbGlow" opacity="0.26"
            [attr.filter]="'url(#' + uid + '-glow)'"></circle>
    <circle cx="60" cy="60" [attr.r]="orbR" fill="#0C1720"></circle>
    <g [attr.clip-path]="'url(#' + uid + '-orbclip)'" [attr.transform]="orbTransform">
      <circle *ngFor="let s of orbStars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
              fill="#FFFFFF" opacity="0.9"></circle>
      <g [attr.filter]="'url(#' + uid + '-soft)'">
        <path *ngFor="let b of orbBands" [attr.d]="b.d" [attr.fill]="b.fill"
              [attr.opacity]="b.o"></path>
      </g>
    </g>
  </ng-container>

  <!-- One rim weight on all eight assets; only its colour changes with state:
       the theme's deep saturated navy once the digit is in, the same navy
       drained of colour while it is still to come. -->
  <circle cx="60" cy="60" [attr.r]="orbR" fill="none"
          [attr.stroke]="on ? 'url(#' + uid + '-orbrim)' : orbRimOff"
          [attr.stroke-width]="orbStroke"></circle>
</svg>

<!-- AUTUMN: the maple from the theme's own icon, one per digit (2026-08-13),
     traced rather than drawn — see line-maple-glyph. ON = the leaf lit, ember at
     the base into amber at the crown with its veins in bark, over a warm halo;
     OFF = the same blade as an empty outline in one muted tone. -->
<svg *ngIf="variant === 'maple'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <linearGradient [attr.id]="uid + '-maple'" x1="0" y1="1" x2="0.25" y2="0">
      <stop offset="0" [attr.stop-color]="mapleDeep"></stop>
      <stop offset="0.5" [attr.stop-color]="mapleMid"></stop>
      <stop offset="1" [attr.stop-color]="mapleLight"></stop>
    </linearGradient>
  </defs>

  <g *ngIf="on" [attr.transform]="mpTransform">
    <path [attr.d]="mapleBlade" [attr.fill]="mapleGold" opacity="0.3"
          [attr.filter]="'url(#' + uid + '-glow)'"></path>
    <path [attr.d]="mapleBlade" [attr.fill]="'url(#' + uid + '-maple)'"></path>
  </g>

  <g *ngIf="!on" [attr.transform]="mpTransform">
    <path [attr.d]="mapleBlade" fill="none" [attr.stroke]="mapleOff" stroke-width="4"
          stroke-linejoin="round"></path>
  </g>
</svg>

<!-- SEQUOIA: a single leaf per digit (owner 2026-08-13) — a classic broad
     blade with its midrib and veins, the theme's foliage at a size where a
     needled frond only read as thin. ON = the leaf filled, shading from deep
     forest at the base to new growth at the tip, over a soft halo; OFF = the
     same blade as an empty outline in one muted tone. -->
<svg *ngIf="variant === 'tree'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <linearGradient [attr.id]="uid + '-leaf'" x1="0" y1="1" x2="1" y2="0">
      <stop offset="0" [attr.stop-color]="treeDark"></stop>
      <stop offset="0.55" [attr.stop-color]="treeMid"></stop>
      <stop offset="1" [attr.stop-color]="treeLight"></stop>
    </linearGradient>
  </defs>

  <g *ngIf="on" [attr.transform]="trTransform">
    <path [attr.d]="leafBlade" [attr.fill]="treeLight" opacity="0.3"
          [attr.filter]="'url(#' + uid + '-glow)'"></path>
    <path [attr.d]="leafBlade" [attr.fill]="'url(#' + uid + '-leaf)'"></path>
    <path [attr.d]="leafVeins" fill="none" stroke="#EAF6DC" stroke-width="1.9"
          stroke-linecap="round" opacity="0.55"></path>
  </g>

  <g *ngIf="!on" [attr.transform]="trTransform">
    <path [attr.d]="leafBlade" fill="none" [attr.stroke]="treeOff" stroke-width="4.4"
          stroke-linejoin="round"></path>
    <path [attr.d]="leafVeins" fill="none" [attr.stroke]="treeOff" stroke-width="2"
          stroke-linecap="round" opacity="0.8"></path>
  </g>
</svg>

<!-- MIAMI: a PALM per digit (owner 2026-08-13) — the foreground of the theme's
     own icon and the same tree its Home tab draws. TWO TONES when entered (owner
     2026-08-13): the trunk holds the palette's dark pink and only the canopy
     lights up in the theme colour, over a soft halo. Unentered = the very same
     tree filled entirely in that pink, so nothing moves between the states
     except the light. Rotated a few degrees per digit so the four lean
     differently. -->
<svg *ngIf="variant === 'palm'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Tighter than the other variants' glow (7). The fronds reach much closer
         to the box edge than a round dot does, so a 7px halo was clipped flat
         along the border — faint (4-5% alpha) but a hard cut all the same.
         Shrinking the halo keeps the tree at full size; widening the fit would
         have shrunk the artwork to make room for a blur. -->
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="4.2"></feGaussianBlur>
    </filter>
  </defs>

  <g *ngIf="on" [attr.transform]="plTransform">
    <path [attr.d]="palmCrown" [attr.fill]="color" opacity="0.3"
          [attr.filter]="'url(#' + uid + '-glow)'"></path>
    <path [attr.d]="palmTrunk" [attr.fill]="palmTrunkInk"></path>
    <path [attr.d]="palmCrown" [attr.fill]="color"></path>
  </g>

  <g *ngIf="!on" [attr.transform]="plTransform" [attr.fill]="palmOff">
    <path [attr.d]="palmTrunk"></path>
    <path [attr.d]="palmCrown"></path>
  </g>
</svg>

<!-- ISTANBUL: a SEAGULL per digit (owner 2026-08-14: "martılar"). The same
     bird the shared line-bird-glyph module flies over Roraima's wallpaper, at
     the same weight, drawn big enough to fill the tile alone. All four are ONE
     drawing and differ only in colour — no tilt, no pose change per digit.
     ON = the gull filled over a soft halo of its own colour; OFF = the same
     gull flat in the single pale tone every unentered dot shares. Flat and not
     outlined: an outline of this silhouette is two hairlines at 22px. -->
<svg *ngIf="variant === 'gull'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Tighter than the round variants' 8, for the palm's reason: the wings
         reach to 10 units of the box edge, so a wide blur is cut flat there. -->
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="4.5"></feGaussianBlur>
    </filter>
  </defs>

  <g [attr.transform]="gullTilt">
    <ng-container *ngIf="on">
      <path [attr.d]="gullPath" [attr.fill]="color" opacity="0.34"
            [attr.filter]="'url(#' + uid + '-glow)'"></path>
      <path [attr.d]="gullPath" [attr.fill]="color"></path>
    </ng-container>

    <path *ngIf="!on" [attr.d]="gullPath" [attr.fill]="gullOff"></path>
  </g>
</svg>

<!-- PARIS: the EIFFEL TOWER per digit (owner 2026-08-14: "tüm passcode'lar
     eiffel kulesi olacak"), the same tower the Home tab draws, so the two
     screens are one glyph.
     This screen is INVERTED — the dots sit on the skin's PALE rose upper zone,
     not on a coloured block — so unlike every other variant here the tower is
     DARK when entered and pale when not. ON = the solid tower in one of four
     deepening tones with its platform bands picked out a shade darker; OFF =
     the same contour flat in a pale rose. The arch under the legs stays a real
     hole in both states: it is the one detail that says Eiffel and not Tokyo. -->
<svg *ngIf="variant === 'eiffel'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <ng-container *ngIf="on">
    <path [attr.d]="eiffelSolid" [attr.fill]="color" fill-rule="evenodd"></path>
    <path [attr.d]="eiffelDecks" [attr.fill]="color" opacity="0.55"></path>
    <path [attr.d]="eiffelShade" fill="#FFFFFF" opacity="0.22"></path>
  </ng-container>

  <path *ngIf="!on" [attr.d]="eiffelSolid" [attr.fill]="eiffelOff" fill-rule="evenodd"></path>
</svg>

<!-- RIO DE JANEIRO: a PLAJ ŞEMSİYESİ per digit — the beach parasol, two colours
     (owner 2026-08-14). It replaces Cristo Redentor here; the statue keeps the
     Home tab, where it appears once. The dots sit on this skin's WHITE upper
     zone, so ON is the parasol in full colour with the GREEN panels on the
     outside carrying its edge, and OFF is the same silhouette flat in one pale
     green. All four entered dots are identical — with a two-colour object a
     per-digit tint has nowhere to go that does not break the pair. -->
<svg *ngIf="variant === 'parasol'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <!-- every dot leans by its own angle, about the point where the pole enters
       the sand — a planted parasol pivots there, not about its middle -->
  <g [attr.transform]="parasolTransform">
    <ng-container *ngIf="on">
      <!-- the inner panels are always the yellow; the OUTER ones and the pole
           take this dot's own colour, so the row alternates green and blue
           without either half of the pair moving -->
      <path [attr.d]="parasolB" [attr.fill]="parasolYellow" fill-rule="nonzero"></path>
      <path [attr.d]="parasolA" [attr.fill]="color" fill-rule="nonzero"></path>
      <path [attr.d]="parasolPole" [attr.fill]="color" fill-rule="nonzero"></path>
    </ng-container>

    <path *ngIf="!on" [attr.d]="parasolPath" [attr.fill]="parasolOff" fill-rule="nonzero"></path>
  </g>
</svg>

<!-- TALLINN: a KAR TANESİ per digit — the same six-armed flake the Home tab and
     the chat wallpaper draw. The dots sit on the skin's CYAN upper zone, so ON is
     the flake in one of four ice tints (white at the end) and OFF is the same
     path flat in one pale sea glass. A flake has no interior parts worth picking
     out at this size, so the two states differ only in colour. -->
<svg *ngIf="variant === 'snowflake'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <path [attr.d]="snowflake" [attr.transform]="snowTransform"
        [attr.fill]="on ? color : snowOff" fill-rule="nonzero"></path>
</svg>

<!-- FUJI: the MOUNTAIN per digit — Fuji itself, the same one the Home tab draws.
     It replaced a pagoda, which was only ever chosen to keep a third triangle out
     of a family that already had two mountains; Fuji is not a third anything. The
     dots sit on this skin's PALE BLUSH upper zone, so they are DARK, and the four
     walk ACROSS a dawn rather than down one hue. ON = the rock in the digit's
     colour with its snowcap in near-white; OFF = the bare silhouette, the mountain
     before the light reaches it. -->
<svg *ngIf="variant === 'fuji'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="fujiTransform">
    <path [attr.d]="fujiMount" [attr.fill]="on ? color : fujiOff"></path>
    <!-- The cap is drawn on the UNENTERED dot too, cut in the zone's own colour.
         Without it an empty slot is a plain triangle, and a plain triangle is a hill
         — this mountain has one identifying feature and the idle state was dropping
         it. Every other theme's OFF keeps its subject and only loses its colour. -->
    <path [attr.d]="fujiSnow" [attr.fill]="on ? fujiSnowColor : fujiSnowCut"></path>
  </g>
</svg>

<!-- ETNA: a YANARDAĞ per digit — the same volcano the Home tab draws. The dots sit
     on this skin's NEAR-BLACK upper zone and the four HEAT UP: cooled basalt, rock
     that is still hot, moving lava, then the orange at the vent. ON = the cone in
     dark rock with lava out of a lit crater and a faint plume; OFF = one flat
     silhouette with nothing coming out of it, which for a volcano is what unlit
     means. -->
<svg *ngIf="variant === 'volcano'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="volcanoTransform">
    <ng-container *ngIf="on">
      <path [attr.d]="volcanoPlume" [attr.fill]="volcanoAsh" opacity="0.95"
            fill-rule="nonzero"></path>
      <path [attr.d]="volcanoShoulder" [attr.fill]="volcanoRock"></path>
      <path [attr.d]="volcanoCone" [attr.fill]="volcanoRock"></path>
      <path [attr.d]="volcanoRiver" [attr.fill]="color" fill-rule="nonzero"></path>
      <path [attr.d]="volcanoFissure" [attr.fill]="color" fill-rule="nonzero"></path>
      <path [attr.d]="volcanoGlow" [attr.fill]="volcanoVent"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="volcanoSolid" [attr.fill]="volcanoOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- MADRID: a CLAVEL per digit — the carnation, the same flower the Home tab
     draws. It is the city's own: what a chulapa wears at San Isidro, and what a
     flamenca wears too. A rose belongs to the generic Spanish-dancer picture and
     to half of Europe besides.

     The dots sit on this skin's CREAM upper zone, so they are DARK, and all four
     are RED: a half-open pink, two deeper dyes, then a full-blown one in shadow.
     ON = the head in the digit's red over a deeper inner ring, on foliage in the
     theme's fixed green; OFF = the whole plant flat in a pale sand. -->
<svg *ngIf="variant === 'clavel'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="clavelTransform">
    <ng-container *ngIf="on">
      <path [attr.d]="clavelFoliage" [attr.fill]="clavelGreen" fill-rule="nonzero"></path>
      <path [attr.d]="clavelHead" [attr.fill]="color" fill-rule="nonzero"></path>
      <path [attr.d]="clavelInner" [attr.fill]="clavelShade" fill-rule="nonzero"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="clavelSolid" [attr.fill]="clavelOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- VIENNA: a KEMAN per digit — the same violin the Home tab draws. The dots sit
     on this skin's DEEP WINE upper zone and the four WARM UP rather than changing
     subject: aged wood, varnish catching the light, the imperial gold, then the
     full house-lights cream. ON = the instrument in the digit's own colour with
     its f-holes and bridge cut in the dark of the body's inside and the strings a
     pale hairline; OFF = one flat silhouette, very nearly the velvet it is lying
     on, which is what the back of a dark auditorium looks like. -->
<svg *ngIf="variant === 'violin'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- The house light the instrument is lying in. A RADIAL GRADIENT, never a
         flat fill: filled flat it is a disc parked behind the violin rather than
         light falling on it — the mistake Prague's first lamp halo made. -->
    <radialGradient [attr.id]="uid + '-vnglow'">
      <stop offset="0" [attr.stop-color]="violinShine" stop-opacity="0.40"></stop>
      <stop offset="1" [attr.stop-color]="violinShine" stop-opacity="0"></stop>
    </radialGradient>
  </defs>
  <g [attr.transform]="violinTransform">
    <ng-container *ngIf="on">
      <circle cx="60" cy="72" r="52" [attr.fill]="'url(#' + uid + '-vnglow)'"></circle>
      <path [attr.d]="violinSolid" [attr.fill]="color" fill-rule="nonzero"></path>
      <!-- the varnish, then the holes cut into it, then the strings over
           everything: light on the body, dark through it, hair across it -->
      <!-- Both are SOFT. At a 0.72 mix and full opacity the sheen came back as a
           cream streak that read as a tear in the body rather than as light on it;
           varnish is a sheen, and a sheen is barely there. -->
      <path [attr.d]="violinShade" [attr.fill]="violinDark" opacity="0.38"></path>
      <path [attr.d]="violinSheen" [attr.fill]="violinShine" opacity="0.55"></path>
      <path [attr.d]="violinFholes" [attr.fill]="violinInside" fill-rule="nonzero"></path>
      <path [attr.d]="violinBridge" [attr.fill]="violinInside"></path>
      <path [attr.d]="violinStrings" [attr.fill]="violinString" opacity="0.9"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="violinSolid" [attr.fill]="violinOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- SPRING: an upward-facing ÇİÇEK per digit — the same flower the Home tab
     draws. It replaced a bellflower, which nodded, and a nodding flower reads as
     a sad one. The dots sit on this skin's WHITE upper zone, so they are DARK:
     ON is the whole plant in the digit's colour with a deeper eye at the centre
     of the head; OFF the same silhouette flat in one pale meadow green. -->
<svg *ngIf="variant === 'flower'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="flowerTransform">
    <ng-container *ngIf="on">
      <path [attr.d]="flowerFoliage" [attr.fill]="flowerGreen" fill-rule="nonzero"></path>
      <path [attr.d]="flowerHead" [attr.fill]="color"></path>
      <path [attr.d]="flowerShade" [attr.fill]="flowerShadeTone"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="flowerSolid" [attr.fill]="flowerOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- REYNISFJARA: the STUÐLABERG per digit — the same basalt cluster the Home tab
     draws. It replaced a puffin, which the owner read as a penguin. The dots sit
     on this skin's DARK upper zone, so they LIGHT UP: ON is the lit faces in the
     digit's colour with the shaded faces deeper and the broken tops paler; OFF is
     the same silhouette flat in one tone barely off the ground. -->
<svg *ngIf="variant === 'basalt'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <ng-container *ngIf="on">
    <path [attr.d]="basaltFaces" [attr.fill]="color" fill-rule="nonzero"></path>
    <path [attr.d]="basaltFacesAlt" [attr.fill]="basaltAltTone" fill-rule="nonzero"></path>
    <path [attr.d]="basaltTops" [attr.fill]="basaltTopTone" fill-rule="nonzero"></path>
  </ng-container>
  <path *ngIf="!on" [attr.d]="basaltSolid" [attr.fill]="basaltOff"
        fill-rule="nonzero"></path>
</svg>

<!-- SYDNEY: a YELKENLİ per digit — the same harbour yacht the Home tab draws. It
     replaced the Opera House. The dots sit on this skin's PALE HARBOUR upper zone,
     so they are DARK: ON is the mainsail in the digit's colour, the jib a step
     lighter and the hull a step deeper; OFF the same silhouette flat in one pale
     harbour grey. No halo — a glow behind a dark mark on a pale ground is a
     smudge. -->
<svg *ngIf="variant === 'yacht'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="yachtTransform">
    <ng-container *ngIf="on">
      <path [attr.d]="yachtHull" [attr.fill]="yachtHullTone"></path>
      <path [attr.d]="yachtMast" [attr.fill]="yachtHullTone" fill-rule="nonzero"></path>
      <path [attr.d]="yachtMain" [attr.fill]="color"></path>
      <path [attr.d]="yachtJib" [attr.fill]="yachtJibTone"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="yachtSolid" [attr.fill]="yachtOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<svg *ngIf="variant === 'lamp'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <radialGradient [attr.id]="uid + '-lampglow'">
      <stop offset="0" [attr.stop-color]="lampLit" stop-opacity="0.55"></stop>
      <stop offset="1" [attr.stop-color]="lampLit" stop-opacity="0"></stop>
    </radialGradient>
  </defs>
  <g [attr.transform]="lampTransform">
    <ng-container *ngIf="on">
      <!-- the halo is a RADIAL GRADIENT, never a flat fill: filled flat it is a
           hard-edged disc parked behind the lamp rather than light coming off it -->
      <circle cx="60" cy="42" r="40" [attr.fill]="'url(#' + uid + '-lampglow)'"></circle>
      <path [attr.d]="lampGlass" [attr.fill]="lampLit" fill-rule="nonzero"></path>
      <path [attr.d]="lampIron" [attr.fill]="color" fill-rule="nonzero"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="lampSolid" [attr.fill]="lampOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- SALDA: a DENİZ KABUĞU per digit — the same scallop the Home tab and the chat
     wallpaper draw. The dots sit on this skin's PALE SAND upper zone, so the
     shells are DARK: ON is the shell filled in the digit's own colour with its
     ribs a step deeper, OFF the same silhouette flat in one sandstone. No halo —
     a glow behind a dark mark on a pale ground is a smudge, which is the one
     thing that does not carry over from Ocean's lit version of this idea. -->
<svg *ngIf="variant === 'shell'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <g [attr.transform]="shellTransform">
    <ng-container *ngIf="on">
      <path [attr.d]="shellEars" [attr.fill]="shellRibColor" fill-rule="nonzero"></path>
      <path [attr.d]="shellBody" [attr.fill]="color" fill-rule="nonzero"></path>
      <path [attr.d]="shellRibs" [attr.fill]="shellRibColor" opacity="0.8"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="shellSolid" [attr.fill]="shellOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- OCEAN: a DENİZANASI per digit — the same jellyfish the Home tab and the chat
     wallpaper draw. The dots sit on this skin's DARK upper zone, so ON is the
     animal LIT: the bell in the digit's own colour over deeper strands, a pale
     crest inside the dome and a soft halo behind the whole thing. OFF is the same
     silhouette flat in one deep sea-slate, the tone every unentered dot shares.
     Each leans by its own small angle about the top of its bell, so four of them
     read as four creatures drifting rather than as one asset stamped out. -->
<svg *ngIf="variant === 'jellyfish'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="9"></feGaussianBlur>
    </filter>
  </defs>
  <g [attr.transform]="jellyTransform">
    <ng-container *ngIf="on">
      <path [attr.d]="jellyBell" [attr.fill]="color" opacity="0.38"
            [attr.filter]="'url(#' + uid + '-glow)'"></path>
      <path [attr.d]="jellyTentacles" [attr.fill]="jellyDeep" fill-rule="nonzero"></path>
      <path [attr.d]="jellyArms" [attr.fill]="jellyDeep" fill-rule="nonzero"></path>
      <path [attr.d]="jellyBell" [attr.fill]="color" fill-rule="nonzero"></path>
      <path [attr.d]="jellyCrest" [attr.fill]="jellyCrestColor" opacity="0.9"></path>
    </ng-container>
    <path *ngIf="!on" [attr.d]="jellySolid" [attr.fill]="jellyOff"
          fill-rule="nonzero"></path>
  </g>
</svg>

<!-- RORAIMA: a SETTING SUN per digit (owner 2026-08-13) — the theme's own
     subject, and the same sun the menu strip puts behind the walls. It sits
     LOWER and deepens in colour on each entered digit, so the four are one
     sunset rather than four variations. ON = the disc lit over a halo, rays
     shortening as it drops, two thin clouds crossing it; OFF = the same sun
     empty, an outlined disc and rays on the horizon. Everything below the
     horizon is clipped, which is what makes it read as SETTING. -->
<svg *ngIf="variant === 'sun'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <clipPath [attr.id]="uid + '-sky'">
      <rect x="0" y="0" width="120" [attr.height]="sunHorizonY"></rect>
    </clipPath>
    <linearGradient [attr.id]="uid + '-sun'" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" [attr.stop-color]="sunLight"></stop>
      <stop offset="1" [attr.stop-color]="sunDeep"></stop>
    </linearGradient>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="8"></feGaussianBlur>
    </filter>
  </defs>

  <ng-container *ngIf="on">
    <g [attr.clip-path]="'url(#' + uid + '-sky)'">
      <circle cx="60" [attr.cy]="sunCy" [attr.r]="sunR * 1.5" [attr.fill]="sunDeep"
              opacity="0.3" [attr.filter]="'url(#' + uid + '-glow)'"></circle>
      <path [attr.d]="sunRaysD" fill="none" [attr.stroke]="sunLight" stroke-width="5"
            stroke-linecap="round" opacity="0.9"></path>
      <circle cx="60" [attr.cy]="sunCy" [attr.r]="sunR" [attr.fill]="'url(#' + uid + '-sun)'"></circle>
      <g [attr.fill]="sunDeep" opacity="0.5">
        <path [attr.d]="sunWisp" [attr.transform]="sunWisp1"></path>
        <path [attr.d]="sunWisp" [attr.transform]="sunWisp2"></path>
      </g>
    </g>
    <path [attr.d]="sunHorizonD" fill="none" [attr.stroke]="sunDeep" stroke-width="6"
          stroke-linecap="round"></path>
  </ng-container>

  <ng-container *ngIf="!on">
    <g [attr.clip-path]="'url(#' + uid + '-sky)'">
      <path [attr.d]="sunRaysD" fill="none" [attr.stroke]="sunOff" stroke-width="4"
            stroke-linecap="round" opacity="0.8"></path>
      <circle cx="60" [attr.cy]="sunCy" [attr.r]="sunR" fill="none" [attr.stroke]="sunOff"
              stroke-width="5"></circle>
    </g>
    <path [attr.d]="sunHorizonD" fill="none" [attr.stroke]="sunOff" stroke-width="5"
          stroke-linecap="round"></path>
  </ng-container>
</svg>

<!-- RORAIMA: a TUMBLEWEED per digit (owner 2026-08-13) — the dry straw ball
     blowing past the tepui, in the theme's own yellow, built to the structure of
     the owner's reference illustrations: hooks escaping the rim, a solid body
     disc, thin tapered stems wrapping across it. ON = the ball lit over a warm
     halo; OFF = the same round object empty, a thin ring with its bristle still
     on it, so unlit reads quieter than lit rather than busier. -->
<svg *ngIf="variant === 'tumbleweed'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="8"></feGaussianBlur>
    </filter>
  </defs>

  <g *ngIf="on" [attr.transform]="twTransform">
    <circle cx="60" cy="60" [attr.r]="tumbleR" [attr.fill]="tumbleStraw" opacity="0.26"
            [attr.filter]="'url(#' + uid + '-glow)'"></circle>
    <!-- hooks first: they read as escaping the ball only from BEHIND it -->
    <path [attr.d]="twHook" [attr.fill]="tumbleStraw"></path>
    <circle cx="60" cy="60" [attr.r]="tumbleR" [attr.fill]="tumbleBody"></circle>
    <path [attr.d]="twWrap" [attr.fill]="tumbleStraw"></path>
  </g>

  <g *ngIf="!on" [attr.transform]="twTransform">
    <path [attr.d]="twHook" [attr.fill]="tumbleOff"></path>
    <circle cx="60" cy="60" [attr.r]="tumbleR" fill="none" [attr.stroke]="tumbleOff"
            stroke-width="4.5"></circle>
  </g>
</svg>

<!-- RORAIMA: the traced tepui per digit — the wall plus its detached pillar,
     with the sun rising a little higher on each entered digit. ON = the wall
     lit, rim catching that digit's own sunset colour, bedding planes picked out
     in shadow; OFF = the same silhouette as an empty outline in one muted tone.
     No per-digit tilt on purpose: a table mountain's rim has to stay level. -->
<svg *ngIf="variant === 'tepui'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="9"></feGaussianBlur>
    </filter>
    <linearGradient [attr.id]="uid + '-tepui'" x1="0" y1="1" x2="0" y2="0">
      <stop offset="0" [attr.stop-color]="tpDeep"></stop>
      <stop offset="0.62" [attr.stop-color]="tpMid"></stop>
      <stop offset="1" [attr.stop-color]="color"></stop>
    </linearGradient>
    <radialGradient [attr.id]="uid + '-tsun'">
      <stop offset="0" stop-color="#FFF3D6"></stop>
      <stop offset="0.55" [attr.stop-color]="color"></stop>
      <stop offset="1" [attr.stop-color]="color"></stop>
    </radialGradient>
    <!-- The wall is drawn OVER the sun, so only the arc that clears the rim
         shows and the rim itself reads as the horizon. -->
  </defs>

  <g *ngIf="on">
    <circle [attr.cx]="tpSun.cx" [attr.cy]="tpSunCy" [attr.r]="tpSun.r * 1.9"
            [attr.fill]="color" opacity="0.34"
            [attr.filter]="'url(#' + uid + '-glow)'"></circle>
    <circle [attr.cx]="tpSun.cx" [attr.cy]="tpSunCy" [attr.r]="tpSun.r"
            [attr.fill]="'url(#' + uid + '-tsun)'"></circle>
    <path [attr.d]="tpSpire" [attr.fill]="'url(#' + uid + '-tepui)'"></path>
    <path [attr.d]="tpBody" [attr.fill]="'url(#' + uid + '-tepui)'"></path>
    <path [attr.d]="tpCrown" [attr.fill]="tpCrownFill"></path>
    <path [attr.d]="tpRunnels" fill="none" [attr.stroke]="tpSeam" stroke-width="2"
          stroke-linecap="round" opacity="0.15"></path>
  </g>

  <g *ngIf="!on">
    <!-- Thicker than the other variants' outlines on purpose: the traced rim is
         a run of small steps, and a thin stroke picks every one of them out as a
         separate bump. At 5 the joins merge into one weathered edge. -->
    <path [attr.d]="tpSpire" fill="none" [attr.stroke]="tpOff" stroke-width="5"
          stroke-linejoin="round"></path>
    <path [attr.d]="tpBody" fill="none" [attr.stroke]="tpOff" stroke-width="5"
          stroke-linejoin="round"></path>
  </g>
</svg>

<!-- TOKYO: a soft 4-point twinkle per digit (owner 2026-08-05, the tower is
     retired) — the same sparkle that drifts in the Tokyo chat wallpaper. OFF =
     a faint outline star; ON = a filled star with a soft glowing halo. -->
<svg *ngIf="variant === 'star'" class="pc-dot" viewBox="0 0 120 120"
     preserveAspectRatio="xMidYMid meet"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter [attr.id]="uid + '-glow'" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
  </defs>

  <ng-container *ngIf="on">
    <!-- a broad soft halo + a tighter one so the star really glows -->
    <path [attr.d]="starPath" [attr.transform]="starTransform" [attr.fill]="color" opacity="0.85"
          [attr.filter]="'url(#' + uid + '-glow)'"></path>
    <path [attr.d]="starPath" [attr.transform]="starTransform" [attr.fill]="color"></path>
  </ng-container>

  <!-- OFF: an empty outline star in the same tint, just fainter. -->
  <path *ngIf="!on" [attr.d]="starPath" [attr.transform]="starTransform" fill="none"
        [attr.stroke]="color" stroke-width="5" stroke-linejoin="round" opacity="0.55"></path>
</svg>
